'use client';

import { createSlice } from '@reduxjs/toolkit';

import { IProductDataForm } from '../../types';

const initialState : IProductDataForm  = {
  price: null,
  status: '',
  components: [],
  tags: []
};


export const productFormSlice = createSlice({
  name: 'productForm',
  initialState,
  reducers: {
    updateForm: (state, action) => {
      return {
        ...state, ...action.payload
      }
    },

    updateProductSkus: (state, action) => {
      const productSkus = action.payload || [];
      return {
        ...state, product_skus: productSkus
      }
    }
  },
});

export const { updateForm, updateProductSkus } = productFormSlice.actions;
export default productFormSlice.reducer;